// extracted by mini-css-extract-plugin
export var actions = "_4y-0";
export var actionsContainer = "_4y-7";
export var border = "_4y-1";
export var childFullHeight = "_4y-f";
export var collapse = "_4y-2";
export var content = "_4y-a";
export var contentChild = "_4y-e";
export var fullscreen = "_4y-c";
export var hasLeftRadius = "_4y-k";
export var headerContainer = "_4y-3";
export var headerRow = "_4y-5";
export var hidePadding = "_4y-b";
export var navCollapsedGap = "_4y-l";
export var noScrollX = "_4y-m";
export var noScrollY = "_4y-n";
export var noTopPadding = "_4y-i";
export var optOutTopPadding = "_4y-d";
export var pageMain = "_4y-j";
export var pageOuter = "_4y-g";
export var pagePadding = "_4y-8";
export var pageScroll = "_4y-9";
export var profile = "_4y-o";
export var profileContainer = "_4y-p";
export var profileImage = "_4y-q";
export var profileMain = "_4y-r";
export var profileSubtitle = "_4y-t";
export var profileTitle = "_4y-s";
export var showLeftPadding = "_4y-h";
export var tabsPortalSlot = "_4y-6";
export var tabsWrapper = "_4y-4";
export var title = "_4y-u";